import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import { authConfig } from "../../../api-config/authConfig"

const initialState = {
    removeLoading : false,
    removeResponse : [],
    error : ""
}
// destroy_user_staff_school/{id} 
const removeSuperAdminStaff = createAsyncThunk("api/removeSuperAdminStaff", async(formData) => {
    return await authConfig.post("/destroy_user_staff_admin", formData).then((response) => {
        return response.data
    }).catch((e) => {
        console.log(e, "Error")
    })
})

const RemoveSuperAdminStaffSlice = createSlice({
    name : "RemoveSuperAdminStaffSlice",
    initialState,
    extraReducers: (builder) => {
        builder.
        addCase(removeSuperAdminStaff.pending, (state) => {
            state.removeLoading = true
        })
        .addCase(removeSuperAdminStaff.fulfilled, (state, {payload}) => {
            state.removeResponse = payload
            state.removeLoading = false
        })
        .addCase(removeSuperAdminStaff.rejected, (state) => {
            state.removeLoading = false
            state.error = "Something went wrong!"
        })
    }
})

export {removeSuperAdminStaff}

export default RemoveSuperAdminStaffSlice.reducer